module.exports = __webpack_public_path__ + "img/side seam pocket position.dc4b3c8d.png";